import type { TFunction } from 'next-i18next';

// `discarded_by` is a free-form backend string: besides csm/employer/worker it
// already admits 'ai', and nothing stops a new value appearing. Anything we do
// not recognise yields an empty label, and the caller must not then render a
// sentence that opens with a colon.
export const getDiscardLabel = (discardedBy: string, t: TFunction) => {
  if (discardedBy === 'csm') return t('job-application-page:discarded_by_restworld_manager');
  if (discardedBy === 'employer') return t('job-application-page:discarded_by_the_employer');
  if (discardedBy === 'worker') return t('job-application-page:you_have_withdrawn_your_application');
  return '';
};

export const getSentimentDescription = ({
  discardedBy,
  discardedReason,
  t,
}: {
  discardedBy: string;
  discardedReason: string;
  t: TFunction;
}) => {
  const label = getDiscardLabel(discardedBy, t);
  // The reason is only ever a suffix of a label. With an unrecognised
  // `discarded_by` the label is empty, and the old code still concatenated
  // `": " + reason`, so the user read a line starting with a colon. Show the
  // reason on its own instead.
  if (!label) return discardedReason || '';
  return discardedReason ? `${label}: ${discardedReason}` : label;
};
